export function drawBullet(ctx, bullet, camera) {
  const fill = bullet.color ?? '#fff'
  camera.forEachVisibleCopy(bullet.position.x, bullet.position.y, bullet.radius, (sx, sy) => {
    ctx.save()
    ctx.translate(sx, sy)
    ctx.fillStyle = fill
    ctx.beginPath()
    ctx.arc(0, 0, 2, 0, 2 * Math.PI)
    ctx.closePath()
    ctx.fill()
    ctx.restore()
  })
}
